<template lang="html">
  <div class="slide">
    <svg @click="findCoords" class="canvas" ref="scene" viewBox="0 0 4175 3006">
      <rect ref="frame" id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <defs>
        <filter id="f1" x="-.1" y="-.1">
          <feGaussianBlur in="SourceGraphic" stdDeviation="30" />
        </filter>
        <clipPath id="clip-frame">
          <use xlink:href="#Frame"/>
        </clipPath>
        <mask id="spot-mask">
          <rect x="0" y="0" :width="canvasWidth" :height="canvasHeight" fill="white" />
          <circle cx="3365" cy="1050" r="400" fill="black" filter="url(#f1)" />
        </mask>
      </defs>
      <g clip-path="url(#clip-frame)">
        <g ref="main">
          <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
            <picture>
              <source :srcset="`${publicPath}scenes/judge/main-480w.jpg`" media="(max-width: 480px)">
              <source :srcset="`${publicPath}scenes/judge/main-768w.jpg`" media="(max-width: 768px)">
              <source :srcset="`${publicPath}scenes/judge/main-1280w.jpg`" media="(max-width: 1280px)">
              <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/judge/main.jpg`" />
            </picture>
          </foreignObject>
        </g>
          <rect mask="url(#spot-mask)" ref="spotlight" x="0" y="0" :width="canvasWidth" :height="canvasHeight" fill="rgba(0,0,0,0.5)" />
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width="0.35"
      :tx="0.12" :ty="0.7">
      After they all came back, Max was given another “hat” to wear: the
      community appointed him as a judge for the Bureau of Indian Affairs’
      Court of Indian Offenses. It was unanimous. He was known by Diné as
      aniwii’ ahi joobai, meaning “the kind judge.”
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/judge/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import SceneDialogue from "../SceneDialogue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const main = this.$refs["main"]
    const spot = this.$refs["spotlight"]
    const d = this.$refs["dialogue"].$el
    TweenLite.set(main, {opacity: 0, scale: 1, transformOrigin: "90% center"})
    TweenLite.set(d, {opacity: 0})
    TweenLite.set(spot, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(main, 1, {opacity: 1}), 0.5)
    this.tl.add(TweenLite.to(main, 3, {scale: 1.5}), 1.5)
    this.tl.add(TweenLite.to(d, 1, {opacity: 1}), "-=1")
    this.tl.add(TweenLite.to(spot, 1, {opacity: 1}), "-=1")
  },
  methods: {
    enter() {this.tl.play()}
  },
  components: {
    SceneDialogue,
  }
}
</script>

<style lang="css" scoped>
</style>
